var I = Object.defineProperty;
var p = (n, t, e) => t in n ? I(n, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : n[t] = e;
var i = (n, t, e) => (p(n, typeof t != "symbol" ? t + "" : t, e), e);
import { fabric as s } from "fabric";
import "@turf/turf";
import "./index.es175.js";
import { DEFAULT_CALLOUT_BOX_SIZE as f, getCalloutBoxSizeData as S } from "./index.es176.js";
import { getMaxBoxHeight as B } from "./index.es456.js";
const y = 72, C = 48, b = 8, m = 4, l = {
  thumbnailText: {
    fillColor: "#FFFFFF",
    fontFamily: "Open Sans",
    fontStyle: "normal",
    fontSize: 11,
    fontWeight: 600
  },
  thumbnailTextContainer: {
    fillColor: "#979797"
  }
}, a = {
  idle: {
    default: {
      originX: "center",
      originY: "center",
      fill: "#FFFFFF",
      rx: 4,
      ry: 4
    },
    light: {
      stroke: "#49565D",
      strokeWidth: -1
    },
    dark: {
      stroke: "white",
      strokeWidth: 0
    }
  },
  dragStart: {
    default: {},
    light: {},
    dark: {}
  },
  select: {
    default: {},
    light: {},
    dark: {}
  },
  selectedPOI: {
    default: {},
    light: {},
    dark: {}
  }
};
class k {
  constructor(t) {
    i(this, "objType");
    i(this, "layerGroupId");
    i(this, "subLayerId");
    i(this, "combinedLayerId");
    i(this, "styleType");
    i(this, "poiInfo");
    i(this, "outerBox");
    i(this, "textboxContainer");
    i(this, "nameTextbox");
    i(this, "thumbnailTextGroup");
    i(this, "calloutBoxSizeData");
    i(this, "generate", async () => {
      const t = this.calloutBoxSizeData.fontSizeMultiplier || 1, e = {
        fontFamily: l.thumbnailText.fontFamily,
        fontStyle: l.thumbnailText.fontStyle,
        fontWeight: l.thumbnailText.fontWeight,
        fontSize: l.thumbnailText.fontSize * t,
        lineHeight: 1.5
      }, o = new s.Textbox(this.poiInfo.mainHeader, {
        width: y,
        textAlign: "left",
        fill: l.thumbnailText.fillColor,
        ...e
      }), h = B({
        maxLines: 2,
        ...e
      });
      let r = 1;
      for (; o.calcTextHeight() > h; ) {
        const g = y + C * r;
        o.set({
          width: g
        }), r += 1;
      }
      const x = o.getCenterPoint(), d = o.getBoundingRect(), u = new s.Rect({
        left: x.x,
        top: x.y,
        width: d.width + b,
        height: d.height + b,
        originX: "center",
        originY: "center",
        fill: l.thumbnailTextContainer.fillColor,
        rx: 3,
        ry: 3
      }), T = u.getBoundingRect(), c = new s.Rect({
        left: x.x,
        top: x.y,
        width: T.width + m,
        height: T.height + m,
        ...a.idle.default,
        ...a.idle[this.styleType]
      });
      return this.outerBox = c, this.textboxContainer = u, this.nameTextbox = o, [c, u, o];
    });
    i(this, "getTenantsCalloutBoxObjs", () => (this.thumbnailTextGroup = new s.Group(
      [this.outerBox, this.textboxContainer, this.nameTextbox].filter(
        (t) => t
      )
    ), this.thumbnailTextGroup));
    i(this, "updateStyle", (t, e = "idle") => {
      var o;
      this.styleType = t, (o = this.outerBox) == null || o.set({
        ...a.idle.default,
        ...a.idle[this.styleType],
        ...a[e].default,
        ...a[e][this.styleType]
      });
    });
    t = {
      ...t
    }, this.layerGroupId = t.layerGroupId, this.subLayerId = t.subLayerId, this.combinedLayerId = t.combinedLayerId, this.objType = "ThumbnailText", this.styleType = t.styleType, this.poiInfo = t.poiInfo;
    const { sizeId: e, rangePosition: o } = t.poiCalloutBoxConfig.calloutBoxSize || f;
    this.calloutBoxSizeData = S(this.objType, e, o);
  }
  hasSameProps(t) {
    var h, r;
    if (t.drawType !== "Thumbnail")
      return !1;
    const e = this.calloutBoxSizeData.id;
    return (((r = (h = t.calloutBoxConfig) == null ? void 0 : h.calloutBoxSize) == null ? void 0 : r.sizeId) || f.sizeId) === e;
  }
}
export {
  k as ThumbnailText,
  a as outerBoxStyle
};
//# sourceMappingURL=index.es513.js.map
